export default __webpack_public_path__ + "static/media/no-image.e16d7674.png";